import { useEffect } from "react";
import Lenis from "lenis";
import { Navbar } from "../components/landing/Navbar";
import { Hero } from "../components/landing/Hero";
import { Marquee } from "../components/landing/Marquee";
import { CSENeeds } from "../components/landing/CSENeeds";
import { ThreeLevers } from "../components/landing/ThreeLevers";
import { HotelsPricing } from "../components/landing/HotelsPricing";
import { Program21 } from "../components/landing/Program21";
import { FAQ } from "../components/landing/FAQ";
import { Coaches } from "../components/landing/Coaches";
import { LeadForm } from "../components/landing/LeadForm";
import { Footer } from "../components/landing/Footer";

export default function Landing() {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    let raf;
    const loop = (time) => {
      lenis.raf(time);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
    };
  }, []);

  return (
    <div className="bg-sand-light" data-testid="landing-page">
      <Navbar />
      <main>
        <Hero />
        <Marquee />
        <CSENeeds />
        <ThreeLevers />
        <HotelsPricing />
        <Program21 />
        <FAQ />
        <Coaches />
        <LeadForm />
      </main>
      <Footer />
    </div>
  );
}
